var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.368 9.74592C0.375706 8.91292 0.711338 8.11651 1.30217 7.52925L8.09467 0.720921C8.39133 0.426024 8.79262 0.260499 9.21092 0.260499C9.62921 0.260499 10.0305 0.426023 10.3272 0.720921C10.4756 0.868112 10.5934 1.04323 10.6737 1.23617C10.7541 1.42912 10.7955 1.63607 10.7955 1.84509C10.7955 2.05411 10.7541 2.26106 10.6737 2.454C10.5934 2.64694 10.4756 2.82206 10.3272 2.96925L5.118 8.16259L20.9513 8.16259C21.3713 8.16259 21.774 8.3294 22.0709 8.62633C22.3679 8.92327 22.5347 9.32599 22.5347 9.74592C22.5347 10.1658 22.3679 10.5686 22.0709 10.8655C21.774 11.1624 21.3713 11.3293 20.9513 11.3293L5.118 11.3293L10.3272 16.5384C10.6253 16.8345 10.7936 17.2368 10.7951 17.657C10.7966 18.0771 10.6311 18.4807 10.3351 18.7788C10.039 19.077 9.63668 19.2453 9.21652 19.2468C8.79636 19.2483 8.39282 19.0828 8.09467 18.7868L1.30217 11.9784C0.707488 11.3873 0.371537 10.5844 0.368 9.74592Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.4a36e5f89513b98da572b1b33d58002d.svg";
export { ForwardRef as ReactComponent };